
export class SigPACModel {
    referencia = '';
    provincia = '';
    municipio = '';
    poligono = '';
    parcela = '';
    recinto = '';
    superficie = '';
    usoSigpac = '';
    tasksRiego: any[] = [];
}